import { BigFormRow, MediumFormRow } from 'framework/ui/layout';
import { Box } from '@mui/material';
import { EnumDropdown } from 'framework/form';
import { UPLOADED_VENDOR_DOCUMENT_TYPES_VALUES } from '../constants';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';
import { useAuthorization } from 'framework/authorization';
import { FINANCE_VENDOR_CREATE } from 'domain/finance/vendors/constants';

const VendorDocumentsForm = ({ isEditForm = false }: { isEditForm?: boolean }) => {
  const { isGranted } = useAuthorization();

  const { CONTRACT, ...restOptions } = UPLOADED_VENDOR_DOCUMENT_TYPES_VALUES;
  const documentTypes = isGranted(FINANCE_VENDOR_CREATE) ? UPLOADED_VENDOR_DOCUMENT_TYPES_VALUES : restOptions;

  return (
    <Box>
      <MediumFormRow>
        <EnumDropdown options={documentTypes} label="" placeholder="Type" source="fileType" />
      </MediumFormRow>

      <BigFormRow>
        <NoteAttachmentUploaderInput isVisible={!isEditForm} isNewDocumentStorage label="" source="paths" />
      </BigFormRow>
    </Box>
  );
};

export default VendorDocumentsForm;
